import {Creature, WarriorClass} from "@/store/level/types";
import {EffectType} from "@/store/artifact/types";
import {Amount} from "@/model/amount";
import {Balance, Player} from "@/store/player/types";

export interface ShopState {
    shopCreatures: ShopCreature[];
    bankOptions: BankOption[];
    bankGifts: BankGift[];
    artifactOptions: ShopArtifact[];
    boosters: BoostersDto | undefined;
    bonusStatus: BonusStatusInfo | undefined;
    rewardedInfo: RewardedInfo | undefined;
}

export class ShopCreature {
    id!: string;
    creature!: Creature;
    creatures!: Creature[];
    titles!: string[];
    descriptions!: string[];
    oldPrice!: number;
    price!: number;
    newCreature!: boolean;
    bunchTitle!: string;
    bankOption !: BankOption;
}

export class BankOption {

    price!: number;
    title!: string;
    valuteName!: string;

    // =======================
    // Вот эти три поля можно выкосить с фронта. Но с бэка - нельзя, они должны остаться для обратной совместимости
    gems!: number;
    bonus!: number;
    imageId!: string;
    // =======================

    // Новые поля, которые надо использовать для отображения панели с покупкой:
    id!: string;
    description!: string;
    uniqueness!: Uniqueness;
    validTill!: number;
    decorationId!: string;
    items!: PurchaseItem[];
}

export enum Uniqueness {
    USUAL = 'USUAL',
    UNIQUE = 'UNIQUE',
    RARE = 'RARE'
}


export class RobokassaPurchaseData {
    merchantLogin!: string;
    outSum!: string;
    invId!: number;
    description!: string;
    receipt!: string;
    shp_curr!: string;
    shp_user!: string;
    culture!: string;
    encoding!: string;
    signatureValue!: string;
}

export class ShopArtifact {
    bunchId!: string;
    oldPrice!: Amount;
    price!: Amount;
    bunchName!: string;
    artifacts!: SimpleShopArtifact[];
}
export class SimpleShopArtifact {
    atlasKey!: string;
    imageKey!: string;
    name!: string;
    effectType!: EffectType;
    effectValue!: number;
    effectMaxValue!: number;
    level!: number;
    maxLevel!: number;
    targets!: ShopArtifactTarget[];
    biggestDiscount!: number;
    artifactId!: string;

}

export class ShopForce {
    warriorClass!: WarriorClass;
    name!: string;
    content!: string;
    price!: number;
    creatureId!: number;
    exist!: boolean;
}

export class ShopArtifactTarget {
    creatureId!: number;
    prices!: ShopArtifactTargetPrice[];
}

export class ShopArtifactTargetPrice {
    oldUnlockPrice!: number;
    newUnlockPrice!: number;
    hasFreeSlots!: boolean;
    discount!: number;
}

export class CreaturePrice {
    creatureId!: number;
    price!: number;
}

export class HeroExchangeOptions {

    shopCreatures!: ShopCreature[];
    myCreaturePrices!: CreaturePrice[];
}

export class HeroExchangeDetails {
    price!: number;
    additionalAttack!: number;
}

export class BoostersDto {
    boosters!: BoosterDto[];
    myBoosters!: ActiveBooster[];
    balance!: Balance;
    currentTime!: string;
}

export class BoosterDto {
    boosterType!: BoosterType;
    name!: string;
    desc!: string;
    hours!: number;
    initialPrice!: number;
    finalPrice!: number;
    bonuses!: BonusConfig[];
    sumType!: SumType;
    validTill!: string;
}

export class BonusConfig {
    boosterNarrowCategory!: BoosterNarrowCategory;
    ratio!: number;
}

export class ActiveBooster {
    boosterType!: BoosterType;
    validTill!: string;
}

export enum SumType {
    UNAVAILABLE = 'UNAVAILABLE',
    REPLACE = 'REPLACE',
    BUY = 'BUY',
    APPEND = 'APPEND'
}

export enum BoosterNarrowCategory {
    EXP = 'EXP',
    HEALTH = 'HEALTH',
    RECOVER = 'RECOVER'
}

export enum BoosterType {
    EXP_SMALL = 'EXP_SMALL',
    EXP_MIDDLE = 'EXP_MIDDLE',
    EXP_BIG = 'EXP_BIG',
    HEALTH_SMALL = 'HEALTH_SMALL',
    HEALTH_MIDDLE = 'HEALTH_MIDDLE',
    HEALTH_BIG = 'HEALTH_BIG',
    RECOVER_SMALL = 'RECOVER_SMALL',
    RECOVER_MIDDLE = 'RECOVER_MIDDLE',
    RECOVER_BIG = 'RECOVER_BIG',
    COMPLEX_SMALL = 'COMPLEX_SMALL',
    COMPLEX_MIDDLE = 'COMPLEX_MIDDLE',
    COMPLEX_BIG = 'COMPLEX_BIG'
}

export class PurchaseInfo {
    paidGemsToTake!: number;
    bonusGemsToTake!: number;
    bonusTicketsToTake!: number;
    pointsToTake!: number;
    remainTillNextStatus!: number;
    healthToAll!: number;
    mythDiscount!: number;
    currentStatus!: BonusStatus;
    statusAfterPurchase!: BonusStatus;
    nextTargetStatus!: BonusStatus;
    creatures!: Creature[];
    receiveCreatureAfterEmeralds!: boolean;
    booster!: BoosterDto;
    name!: string;
    items!: PurchaseItem[];
}

export class PurchaseItem {
    creature!: Creature;
    itemType!: ItemType;
    id!: string;
    count!: number;
}


export enum ItemType {
    HERO = 'HERO',
    SILVER_CHEST = 'SILVER_CHEST',
    GOLD_CHEST = 'GOLD_CHEST',
    AZURE_CHEST = 'AZURE_CHEST',
    LAVA_CHEST = 'LAVA_CHEST',
    ELEPHANT = 'ELEPHANT',
    GEMS = 'GEMS',
    GEMS_BONUS = 'GEMS_BONUS',
    ATTACK_COMBATIVE = 'ATTACK_COMBATIVE',
    DEFENCE_COMBATIVE = 'DEFENCE_COMBATIVE',
    HEALTH_COMBATIVE = 'HEALTH_COMBATIVE',
    HEALTH = 'HEALTH',
    MYTH_DISCOUNT = 'MYTH_DISCOUNT',
    TICKETS = 'TICKETS',
    GEMS_BONUS_PROGRAM = 'GEMS_BONUS_PROGRAM',
    AMBER_CHEST = 'AMBER_CHEST',
    JADE_CHEST = 'JADE_CHEST'
}

export class BonusStatusInfo {
    points!: number;
    validTill!: string;
    remainTime!: string;
    status!: BonusStatus;
    nextStatus!: BonusStatus;
    currentBonusPercent!: number;
    remainTillNextStatus!: number;
}

export class RewardedInfo {
    todayWatchTimes!: number;
    maxWatchTimes!: number;
    reward!: number;
    enabled!: boolean;
}

export class RewardedResult {
    reward!: number;
    player!: Player;
}

export class BankDto {
    bankOptions!: BankOption[];
    bankGifts!: BankGift[];
    bonusStatusInfo!: BonusStatusInfo;
    rewardedInfo!: RewardedInfo;
}

export class BankGift {
    id!: number;
    name!: string;
    identifier!: string;
    gems!: number;
}


export class PortalShopDto {
    creatures!: ShopCreature[];
    nsCount!: number;
    haveIds!: string[];
}

export enum BonusStatus {
    NONE = 'NONE',
    SILVER = 'SILVER',
    GOLD = 'GOLD',
    BRILLIANT = 'BRILLIANT'
}

export class AvatarDto {
    id!: string;
    price!: number;
}

export enum HeroShopType {
    HERO_TOWN = 'HERO_TOWN',
    TITAN_TOWN = 'TITAN_TOWN',
    ANGEL_TOWN = 'ANGEL_TOWN',
    YOTUN_TOWN = 'YOTUN_TOWN',
    SUR_TOWN = 'SUR_TOWN',
    AMETIST_SHOP = 'AMETIST_SHOP',
    WATER_SHOP = 'WATER_SHOP',
    SHADOW_SHOP = 'SHADOW_SHOP',
    PORTAL_SHOP = 'PORTAL_SHOP'
}

export enum RewardedAdvType {
    GEMS = 'GEMS',
    HEALTH_RESTORE = 'HEALTH_RESTORE',
    SPEEDUP_ARENA = 'SPEEDUP_ARENA'
}